export default __webpack_public_path__ + "static/media/offerSlides2.5bdba807.png";